import { LocationAddress } from "../../Location/Dto/LocationAddressModel";

export enum PartnerType {
  School = "School",
  Church = "Church",
  College = "College",
  Foundation = "Foundation",
  Ministry = "Ministry",
  Government = "Government",
  Other = "Other",
}

export interface Partner {
  id: string;
  name: string;
  type: PartnerType;
  address: LocationAddress;
  phone?: string;
  createdAt: string;
  updatedAt: string;
}
